import { FC, ReactNode } from 'react';

import StatusBadge, { StatusBadgeProps } from '../../../Badge/Status/Status';
import Icon from '../../../Icon';

import s from './DefaultRightSide.module.scss';

export interface DefaultRightSideProps {
  rightIllust?: ReactNode;
  rightBadge?: StatusBadgeProps;
  rightListIcon?: boolean;
}

const DefaultRightSide: FC<React.PropsWithChildren<React.PropsWithChildren<DefaultRightSideProps>>> = ({ rightIllust, rightBadge, rightListIcon }) => {
  return (
    <>
      {rightIllust && <div className={s.illust}>{rightIllust}</div>}
      {rightBadge && <StatusBadge type={rightBadge.type} text={rightBadge.text} isIcon={rightBadge.isIcon} />}
      {rightListIcon && <Icon type="listin-right" width={16} height={24} color="gray.300" />}
    </>
  );
};

export default DefaultRightSide;
